export default [
    {
        path: "/lisapay",
        name: "lisapay.index",
        meta: {
            auth: true,
            hasAccess: true, // no permission check (a settings page is unknown at backend-side)
        },
        component: () =>
            import(
                /* webpackChunkName: "lisapay" */ "@/views/lisapay/Management.vue"
            ),
    },
];